var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 4
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FA637",
    d: "M18.174.81a1.146 1.146 0 110 2.292H1.739a1.146 1.146 0 110-2.291h16.435z"
  })));
}
export default SvgCollapse;